import { Flex } from '@chakra-ui/react';
import { netchexFooterStyles } from 'screens/admin/Reviews/ReviewProcessV2Intent/ReviewProcessV2PresetsFooter';

import { ArrowForward } from 'assets/assetsV1/iconComponents/ArrowForward';

import { isNetchexLogin } from 'constants/netChexConstants';

import { Button } from 'uiToolkitV1/Button';

import { useCreateNewSurveyForm } from './dataHook';

export const SurveyPresetsFooter = ({ selectedSurveyCreationPreset }) => {
  const { mutate: createNewSurveyForm, isLoading: isCreateNewSurveyFormLoading } = useCreateNewSurveyForm({
    selectedSurveyCreationPreset,
  });

  const handleNextClick = () => {
    createNewSurveyForm();
  };

  return (
    <Flex
      py={3}
      px={4}
      justifyContent="flex-end"
      alignItems="center"
      bg="surface.F5F7F9"
      borderTop="1px solid"
      borderColor="border.CFD7DF"
      borderBottomRadius="8px"
      {...(isNetchexLogin ? netchexFooterStyles : {})}
    >
      <Button
        onClick={handleNextClick}
        disabled={isCreateNewSurveyFormLoading}
        StartIcon={isCreateNewSurveyFormLoading ? null : ArrowForward}
      >
        {isCreateNewSurveyFormLoading ? 'Creating ...' : 'Next'}
      </Button>
    </Flex>
  );
};
